import React, { useEffect } from "react";
import { Switch, Route } from "react-router-dom";
import { withCommercePlatform } from "@spscommerce/ui-react";

import LoginCard from "../../components/LoginCard";
import NoUserFound from "./NoUserFound";
import ResetPassword from "./ResetPassword";
import CreateNewPassword from "./CreateNewPassword";
import CreateUser from "./CreateUser";

import { SpsIcon } from "@spscommerce/ds-react";
import { SpsIcon as Icon } from "@spscommerce/ds-shared";
import { NavLink } from "react-router-dom";

function LoginPage(props) {
    const { commercePlatform } = props;

    useEffect(() => {
        document.body.classList.add("sps-wallpaper");

        // Clean up
        return () => {
            document.body.classList.remove("sps-wallpaper");
        };
    });

    return (
        <LoginCard
            topShelf={() => (
                <NavLink to="/home" className="signup-page__nav-link signup-page__nav-link--icon">
                    <SpsIcon icon={Icon.ARROW_LEFT_CIRCLE} />
                    <span>Back to Dev Center Home</span>
                </NavLink>
            )}
        >
            <Switch>
                <Route path="/login/" exact render={() => <h2>Login</h2>} />
                <Route path="/login/no-user-found" component={NoUserFound} />
                <Route path="/login/reset-password" component={ResetPassword} />
                <Route
                    path="/login/create"
                    render={() => {
                        return <CreateUser commercePlatform={commercePlatform} />;
                    }}
                />
                <Route path="/login/create-new-password" component={CreateNewPassword} />
            </Switch>
        </LoginCard>
    );
}

export default withCommercePlatform(LoginPage);
